import { getDeviceId } from "shared/utils/helpers";
import client from "../../../services/client";
// 1 - POST /identity -> give me guest token
// 3 - POST /users/login/otp
// 4 - POST /users/login/otp/verify -> returns access and refresh token
// 2 - POST /users/login/refresh
// 6 - POST /users/change-password
// 7 - POST /users/login/logout
// 8 - POST /users/login/logout/all

const generateGuestTokenAPI = async (payload = {}) => {
  const response = await client.post("/identity", payload, { tokenType: "none" });
  console.log("responseww", response);
  return response;
};
const generateOTPAPI = async (payload) => {
  const response = await client.post("/users/login/otp", payload, {
    tokenType: "guest",
    headers: { "app-type": "OPS_PORTAL", "device-id": getDeviceId() },
  });
  return response;
};
const verifyOTPAPI = async (payload) => {
  const response = await client.post("/users/login/otp/verify", payload, {
    tokenType: "guest",
    headers: { "app-type": "OPS_PORTAL", "device-id": getDeviceId() },
  });
  return response;
};
const refreshTokenAPI = async () => {
  const response = await client.post("/users/login/refresh", {}, { tokenType: "refresh" });
  return response;
};
const changePasswordAPI = async (oldPassword, newPassword) => {
  const response = await client.post(
    "/users/change-password",
    { oldPassword, newPassword },
    { tokenType: "access" }
  );
  return response.data.access_token;
};
const logoutAPI = async () => {
  const response = await client.post("/users/login/logout", {}, { tokenType: "access" });
  return response;
};
const logoutAllAPI = async () => {
  const response = await client.post("/users/login/logout/all", {}, { tokenType: "access" });
  return response;
};

export {
  generateGuestTokenAPI,
  generateOTPAPI,
  verifyOTPAPI,
  refreshTokenAPI,
  changePasswordAPI,
  logoutAPI,
  logoutAllAPI,
};
